import React from 'react';

const WidgetModal = ({ title, onClose, children, fullViewport = false, largeModal = false, closeOnOverlayClick = true, hideCloseButton = false, hideHeader = false }) => {
  const handleOverlayClick = (event) => {
    if (closeOnOverlayClick && event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`modal-overlay${fullViewport ? ' modal-overlay--full' : ''}`}
      role="presentation"
      onClick={handleOverlayClick}
    >
      <div
        className={`modal-content${fullViewport ? ' modal-content--full' : largeModal ? ' modal-content--large' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        {!hideHeader && (
          <header className="modal-header">
            <h2 id="modal-title">{title}</h2>
            {!hideCloseButton && (
              <button type="button" className="icon-button" onClick={onClose} aria-label="Lukk">
                ×
              </button>
            )}
          </header>
        )}
        <div className={`modal-body${fullViewport ? ' modal-body--full' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default WidgetModal;
